import trimMask from '@meta-awesome/functions/src/trimMask'

import size from 'lodash/size'

export default ({ t, validateIfEmpty = true }) => YupInstance => YupInstance
  .test('cep', t('invalid cep'), (value) => validateIfEmpty ? size(trimMask(value)) === 8 : size(trimMask(value)) === 8 || size(trimMask(value)) === 0)
